'use strict';

export default (API) => ({
    places: {
        assignServicesAndResources: (establishmentId, params, filters) => {
            const url = `v3/establishments/${establishmentId}/places/resources/services/assign?filters=${filters}`;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        unassignServicesAndResources: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/places/resources/services/unassign';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        validateUnassignServicesAndResources: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/places/resources/services/unassign?validate=true';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        getServiceAndResourceIndexes(establishmentId, placeId) {
            const url = 'v3/establishments/' + establishmentId + '/places/' + placeId + '/resources/services/indexes';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllServiceAndResourceIndexesByPlace(establishmentId) {
            const url = 'v3/establishments/' + establishmentId + '/places/resources/services/indexes';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        get: (establishmentId, placeId) => {
            const url = 'v3/establishments/' + establishmentId + '/places/' + placeId;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAll: (establishmentId, ignorePrest = false, light = 0) => {
            let url = `v3/establishments/${establishmentId}/places`;
            if(ignorePrest || light > 0) url += '?';
            if(ignorePrest) url += `ignorePrest=${ignorePrest}`;
            if(light) url += ignorePrest ? `&lightSerialize=${light}` : `lightSerialize=${light}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getArchivedPlaces(establishmentId) {
            let url = `v3/establishments/${establishmentId}/places/archived`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAvailable: () => {
            const url = 'v3/places/available';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        create: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/places';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        delete: (establishmentId, placeId, validate) => {
            const url = `v3/establishments/${establishmentId}/places/${placeId}?validate=${validate}`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        update: (establishmentId, id, params) => {
            const url = 'v3/establishments/' + establishmentId + '/places/' + id;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateStatus: (establishmentId, placeId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/places/' + placeId + '/status';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateOrder: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/places/order';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        restorePlace: (establishmentId, placeId) => {
            const url = `v3/establishments/${establishmentId}/places/${placeId}/restore`;
            const request = API.http.put(url, '', { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        getPlaceSpecificSettings: (establishmentId, placeId, settingIds) => {
            const settingIdsStr = settingIds.join('&settingIds[]=');
            const url = `v3/establishments/${establishmentId}/places/${placeId}/settings?settingIds[]=${settingIdsStr}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createPlaceSettings: (establishmentId, placeId, params) => {
            const url = `v3/establishments/${establishmentId}/places/${placeId}/settings`;
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updatePlaceSettings: (establishmentId, placeId, params) => {
            const url = `v3/establishments/${establishmentId}/places/${placeId}/settings`;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        // place_templates routes
        getTemplates: () => {
            const url = 'v3/places/templates';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createTemplate: (params) => {
            const url = 'v3/places/templates';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateTemplate: (templateId, params) => {
            const url = 'v3/places/templates/' + templateId;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        deleteTemplate: (templateId) => {
            const url = 'v3/places/templates/' + templateId;
            const request = API.http.delete(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        // establishments_place_templates_associations routes
        getAllAssociatedPlaceTemplateByEstablishment: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '/places/associated';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllAssociatedPlaceTemplateByEstablishmentWithStatus: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '/places/associated?withStatus=true';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        associatePlaceTemplate: (establishmentId, placeTemplateId) => {
            const url = `v3/establishments/${establishmentId}/places/${placeTemplateId}/associate`;
            const request = API.http.post(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        dissociatePlaceTemplate:(establishmentId, placeTemplateId) => {
            const url = `v3/establishments/${establishmentId}/places/${placeTemplateId}/dissociate`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
    },
});
